export default __webpack_public_path__ + "static/media/SolutionPage_Image.e2ab4fcb.svg";